/* eslint-disable */
export default {
  removeParticipant: 'Quitar participante',
  confirmStr1: '¿Está seguro de que desea quitar a este participante',
  confirmStr2: 'de esta llamada?',
  remove: 'Quitar',
  cancel: 'Cancelar',
  participants: 'Participantes',
  participant: 'Participante',
  conferenceCall: 'Llamada de conferencia',
  unknownNumber: 'Anónimo',
} as const;

// @key: @#@"removeParticipant"@#@ @source: @#@"Remove Participant"@#@
// @key: @#@"confirmStr1"@#@ @source: @#@"Are you sure you want to remove"@#@
// @key: @#@"confirmStr2"@#@ @source: @#@"from this call?"@#@
// @key: @#@"remove"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"participant"@#@ @source: @#@"Participant"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
